import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api";

function SalairesList() {

  const [personnel, setPersonnel] =
    useState([]);

  const [depenses, setDepenses] =
    useState([]);

  const navigate =
    useNavigate();

  // =====================
  // FETCH
  // =====================

  const fetchData = async () => {

    try {

      const resPers =
        await api.get(
          "/personnel"
        );

      const resDep =
        await api.get(
          "/depenses"
        );

      setPersonnel(
        resPers.data || []
      );

      setDepenses(
        resDep.data.data || []
      );

    } catch (err) {

      console.error(
        "Erreur salaires:",
        err
      );

    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {

    const interval =
      setInterval(
        fetchData,
        3000
      );

    return () =>
      clearInterval(
        interval
      );

  }, []);

  // =====================
  // SECURE ARRAY
  // =====================

  const depensesArray =
    Array.isArray(depenses)
      ? depenses
      : depenses?.data || [];

  // =====================
  // DERNIER PAIEMENT
  // =====================

  const getDernierPaiement =
    (personnelId) => {

      const salaires =
        depensesArray
          .filter(
            (d) =>
              d.categorie ===
                "salaires" &&
              Number(
                d.personnel_id
              ) ===
                Number(
                  personnelId
                ) &&
              d.periode_salaire
          )
          .sort((a, b) =>
            b.periode_salaire.localeCompare(
              a.periode_salaire
            )
          );

      return salaires[0];
    };

  // =====================
  // NEXT MOIS
  // =====================

  const getNextMois =
    (personnelId) => {

      const salaires =
        depensesArray
          .filter(
            (d) =>
              d.categorie ===
                "salaires" &&
              Number(
                d.personnel_id
              ) ===
                Number(
                  personnelId
                ) &&
              d.periode_salaire
          )
          .sort((a, b) =>
            b.periode_salaire.localeCompare(
              a.periode_salaire
            )
          );

      if (
        salaires.length === 0
      ) {

        const now =
          new Date();

        return now.toLocaleString(
          "fr-FR",
          {
            month: "long",
            year: "numeric"
          }
        );
      }

      const [
        year,
        month
      ] =
        salaires[0].periode_salaire.split(
          "-"
        );

      const next =
        new Date(
          year,
          month - 1
        );

      next.setMonth(
        next.getMonth() + 1
      );

      return next.toLocaleString(
        "fr-FR",
        {
          month: "long",
          year: "numeric"
        }
      );
    };

  // =====================
  // STATUT
  // =====================

  const getStatutSalaire =
    (personnelId) => {

      const salaires =
        depensesArray
          .filter(
            (d) =>
              d.categorie ===
                "salaires" &&
              Number(
                d.personnel_id
              ) ===
                Number(
                  personnelId
                ) &&
              d.periode_salaire
          )
          .sort((a, b) =>
            b.periode_salaire.localeCompare(
              a.periode_salaire
            )
          );

      const now =
        new Date();

      const lastMonth =
        new Date(
          now.getFullYear(),
          now.getMonth() - 1
        );

      if (
        salaires.length === 0
      ) {

        return {
          statut: "retard",
          moisRetard:
            "Tous"
        };
      }

      const last =
        salaires[0]
          .periode_salaire;

      const [
        year,
        month
      ] = last.split("-");

      const lastPaidDate =
        new Date(
          year,
          month - 1
        );

      const diff =
        (lastMonth.getFullYear() -
          lastPaidDate.getFullYear()) *
          12 +
        (lastMonth.getMonth() -
          lastPaidDate.getMonth());

      if (diff <= 0) {

        return {
          statut: "paye",
          moisRetard: 0
        };
      }

      if (diff === 1) {

        return {
          statut: "a_payer",
          moisRetard: 1
        };
      }

      return {
        statut: "retard",
        moisRetard: diff
      };
    };

  // =====================
  // FORMAT
  // =====================

  const formatPeriode = (
    periode
  ) => {

    if (!periode) return "-";

    const [
      year,
      month
    ] = periode.split("-");

    const date =
      new Date(
        year,
        month - 1
      );

    return date.toLocaleString(
      "fr-FR",
      {
        month: "long",
        year: "numeric"
      }
    );
  };

  // =====================
  // RENDER
  // =====================

  return (
    <div className="p-3 md:p-6 space-y-4 md:space-y-6 bg-gray-100 min-h-[100dvh]">

      {/* HEADER */}
      <div className="flex flex-col md:flex-row justify-between md:items-center gap-3">

        <h2 className="text-2xl md:text-3xl font-semibold">
          Gestion des salaires
        </h2>

        <button
          onClick={() =>
            navigate(
              "/salaires/historique"
            )
          }
          className="bg-gray-800 text-white px-4 py-3 md:py-2 rounded-xl hover:bg-black transition w-full md:w-auto"
        >
          Voir historique
        </button>

      </div>

      {/* MOBILE */}
      <div className="grid gap-3 md:hidden">

        {personnel.map((p) => {

          const nomComplet = `${p.nom} ${p.prenom}`;

          const paiement =
            getDernierPaiement(
              p.id
            );

          const statutInfo =
            getStatutSalaire(
              p.id
            );

          const prochainMois =
            getNextMois(
              p.id
            );

          return (
            <div
              key={p.id}
              className="bg-white rounded-2xl shadow p-4 border"
            >

              <div className="font-semibold text-base break-words">
                {nomComplet}
              </div>

              <div className="mt-2">

                {statutInfo.statut ===
                  "paye" && (
                  <span className="text-green-600 font-semibold text-sm">
                    ✅ Payé
                  </span>
                )}

                {statutInfo.statut ===
                  "a_payer" && (
                  <span className="text-yellow-600 font-semibold text-sm">
                    ⚠️ À payer
                  </span>
                )}

                {statutInfo.statut ===
                  "retard" && (
                  <span className="text-red-600 font-semibold text-sm">
                    ❌ En retard (
                    {
                      statutInfo.moisRetard
                    }{" "}
                    mois)
                  </span>
                )}

              </div>

              <div className="text-sm text-gray-500 mt-2">
                Dernière période :
              </div>

              <div className="font-medium">
                {formatPeriode(
                  paiement?.periode_salaire
                )}
              </div>

              <button
                onClick={() =>
                  navigate(
                    "/depenses/ajouter",
                    {
                      state: {
                        employeId:
                          p.id
                      }
                    }
                  )
                }
                className="mt-4 w-full bg-blue-600 text-white px-4 py-3 rounded-xl hover:bg-blue-700 transition text-sm"
              >
                Payer (
                {prochainMois})
              </button>

            </div>
          );
        })}

      </div>

      {/* DESKTOP */}
      <div className="hidden md:block bg-white rounded-2xl shadow overflow-x-auto">

        <table className="min-w-full text-sm">

          <thead className="bg-gray-900 text-white">

            <tr>

              <th className="px-4 py-3 text-left">
                Employé
              </th>

              <th className="px-4 py-3 text-left">
                Statut
              </th>

              <th className="px-4 py-3 text-left">
                Dernière période
              </th>

              <th className="px-4 py-3 text-left">
                Action
              </th>

            </tr>

          </thead>

          <tbody>

            {personnel.map(
              (p) => {

                const nomComplet = `${p.nom} ${p.prenom}`;

                const paiement =
                  getDernierPaiement(
                    p.id
                  );

                const statutInfo =
                  getStatutSalaire(
                    p.id
                  );

                const prochainMois =
                  getNextMois(
                    p.id
                  );

                return (
                  <tr
                    key={p.id}
                    className="border-t hover:bg-gray-50 transition"
                  >

                    <td className="px-4 py-3 font-medium">
                      {nomComplet}
                    </td>

                    <td className="px-4 py-3">

                      {statutInfo.statut ===
                        "paye" && (
                        <span className="text-green-600 font-semibold">
                          Payé
                        </span>
                      )}

                      {statutInfo.statut ===
                        "a_payer" && (
                        <span className="text-yellow-600 font-semibold">
                          À payer
                        </span>
                      )}

                      {statutInfo.statut ===
                        "retard" && (
                        <span className="text-red-600 font-semibold">
                          En retard (
                          {
                            statutInfo.moisRetard
                          }{" "}
                          mois)
                        </span>
                      )}

                    </td>

                    <td className="px-4 py-3">
                      {formatPeriode(
                        paiement?.periode_salaire
                      )}
                    </td>

                    <td className="px-4 py-3">

                      <button
                        onClick={() =>
                          navigate(
                            "/depenses/ajouter",
                            {
                              state:
                                {
                                  employeId:
                                    p.id
                                }
                            }
                          )
                        }
                        className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition"
                      >
                        Payer (
                        {
                          prochainMois
                        }
                        )
                      </button>

                    </td>

                  </tr>
                );
              }
            )}

          </tbody>

        </table>

      </div>

    </div>
  );
}

export default SalairesList;